var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-wallet-view"},[_c('navbar'),_c('div',{staticClass:"flex flex-col gap-8 container"},[(
        _vm.displayDisclaimer &&
          !_vm.$.walletAdapter.n3Address &&
          !_vm.$.walletAdapter.xAddress &&
          _vm.$.watchWallet.address
      )?_c('my-wallet-watch-only-disclaimer',{on:{"closeDisclaimer":function($event){_vm.displayDisclaimer = false}}}):_vm._e(),(
        _vm.$.walletAdapter.n3Address ||
          _vm.$.walletAdapter.xAddress ||
          _vm.$.watchWallet.address
      )?_c('div',{staticClass:"flex flex-col gap-16"},[_c('my-wallet-section',{attrs:{"cache-assist":_vm.cacheAssist}}),(_vm.isOrbitEnabled && !_vm.cacheAssist.currentWallet.isWatchWallet)?_c('my-wallet-orbit-overview'):_vm._e(),_c('my-wallet-tokens-nfts-section',{attrs:{"cache-assist":_vm.cacheAssist}}),(
          _vm.cacheAssist.currentWallet.network === 'Neo3' &&
            !_vm.cacheAssist.currentWallet.isWatchWallet
        )?_c('my-wallet-get-gas-section',{attrs:{"cache-assist":_vm.cacheAssist}}):_vm._e()],1):_c('my-wallet-connect-address',{attrs:{"cache-assist":_vm.cacheAssist}})],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }